export function togglePermission(permissions, prop, permission) {
    const list = permissions[prop];
    if (list.includes(permission)) {
        permissions[prop] = list.filter((p) => p !== permission);
    }
    else {
        list.push(permission);
    }
}
